import { useMemo } from "react";
import { useGetCampaignRouletteByIdQuery } from "../../../../../services/campaign-roulette";
import { CampaignType, ICampaignRoulette } from "../../../../../@types/campaign-roulette";
import { mapStatusToFrontend } from "../../utils/status-mapper";

export const useCampaignData = (campaignId: number) => {
  const { data: rawData, isLoading, error } = useGetCampaignRouletteByIdQuery(campaignId);

  const campaign = useMemo(() => {
    if (!rawData) return undefined;

    const item = rawData.data as any;
    
    return {
      id: item.id,
      idCapa: item.idCapa,
      nickname: item.campaignName,
      startDate: item.startDate,
      endDate: item.endDate,
      status: mapStatusToFrontend(item.status, item.deletedAt || null),
      campaignType: item.campaignType || CampaignType.ROULETTE,
      stores: (item.stores || []).map((store: any) => ({
        storeCode: (store.code?.toString() || store.caixa) as string,
        storeName: (store.name || store.nomeLoja) as string,
        nickname: (store.nickname || store.name || store.nomeLoja) as string,
      })),
      hasRegulationFile: item.hasRegulationFile || false,
      hasBanner3x4: item.hasBanner3x4 || false,
      hasBanner16x9: item.hasBanner16x9 || false,
      probabilities: (() => {
        const discountProbs = item.discountProbabilities;
        const probArray = Array.isArray(discountProbs) 
          ? discountProbs 
          : (discountProbs?.intervals || []);
        
        return probArray.map((prob: any) => ({
          prob: prob?.prob || 0,
          prizes: prob?.prizes || []
        }));
      })(),
      regulations: item.regulations,
      createdAt: item.createdAt,
      updatedAt: item.updatedAt,
      deletedAt: item.deletedAt,
      linkedCampaignId: item.linkedCampaignId ?? null,
      linkedCampaignName: item.linkedCampaignName ?? null,
    } as ICampaignRoulette;
  }, [rawData]);

  return {
    campaign,
    isLoading,
    error,
  };
};
